import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { TypeNewsEnum } from 'src/app/data/models/enum/type-news.enum';
import { ImageItem } from '../select-simple-list/model/item-image.interface';

@Component({
  selector: 'app-type-news-select',
  templateUrl: './type-news-select.component.html',
  styleUrls: ['./type-news-select.component.scss'],
})
export class TypeNewsSelectComponent implements OnChanges {
  @Input() statusList: ImageItem[] = [];
  @Input() initialList: string[] = [];

  @Output() onSelectOption = new EventEmitter<string[]>();

  status: ImageItem[] = [
    {
      id: TypeNewsEnum.WITH_AUTHORIZATION,
      name: TypeNewsEnum.WITH_AUTHORIZATION,
      imageUrl: '',
      isChecked: false,
    },
    {
      id: TypeNewsEnum.SCHEDULED,
      name: TypeNewsEnum.SCHEDULED,
      imageUrl: '',
      isChecked: false,
    },
    {
      id: TypeNewsEnum.RELEASED,
      name: TypeNewsEnum.RELEASED,
      imageUrl: '',
      isChecked: false,
    },
    {
      id: TypeNewsEnum.WITHOUT_AUTHORIZATION,
      name: TypeNewsEnum.WITHOUT_AUTHORIZATION,
      imageUrl: '',
      isChecked: false,
    },
  ];

  readonly filterText: string = 'Todas as notícias';
  selectAllText: string = 'Marcar/Desmarcar todas';
  allSelected: boolean = false;
  labelText: string = this.filterText;
  isOpen: boolean = false;
  selectedTypeName: string[] = [];

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.initialList) {
      this.status.forEach((el) => {
        el.isChecked = changes.initialList.currentValue.includes(el.id);
      });
      this.labelText = this.verifyLength(this.status);

      if (changes.initialList.currentValue.length == 0) {
        this.selectedTypeName = [];
        this.labelText = this.filterText;
        this.status.forEach((p) => (p.isChecked = false));
        return
      }
      this.selectedTypeName = changes.initialList.currentValue;
    }
  }

  private verifyLength(typeNews: ImageItem[]): string {
    const countCheckedType = typeNews.filter(
      (typeNews) => typeNews.isChecked
    ).length;
    let typeText = '';
    if (countCheckedType >= 1) {
      typeText = typeNews.filter((typeNews) => typeNews.isChecked)[0].name;
      if (countCheckedType > 1) {
        typeText = typeText
          .concat(' +')
          .concat((countCheckedType - 1).toString());
      }
    }
    return typeText;
  }

  handleTypeSelect(status: ImageItem[]): void {
    this.isOpen = false;
    const selectedOptions = status.filter((item) => item.isChecked);
    const statusName = selectedOptions.map((item) => item.name);
    this.selectedTypeName = statusName as string[];
    const filtered = this.verifyLength(status);
    this.labelText = filtered ? filtered : this.filterText;

    this.onSelectOption.emit(this.selectedTypeName);
    this.initialList = this.selectedTypeName;
  }
}
